import { Square } from "lucide-react";
import { useState } from "react";
import { useCancelReview } from "../hooks/use-cancel-review.js";
import { useReviewPermissions } from "../hooks/use-review-permissions.js";
import { Button } from "./ui/button.js";

type CancelReviewButtonProps = {
  reviewId: string;
  initiallyConfirming: boolean;
};

export function CancelReviewButton({ reviewId, initiallyConfirming }: CancelReviewButtonProps) {
  const [confirming, setConfirming] = useState(initiallyConfirming);
  const cancel = useCancelReview(reviewId);
  const permissions = useReviewPermissions(reviewId);

  if (!permissions.data?.canCancel) return null;

  if (!confirming) {
    return (
      <Button variant="outline" size="sm" onClick={() => setConfirming(true)}>
        <Square />
        Review abbrechen
      </Button>
    );
  }

  return (
    <span className="flex items-center gap-2 text-sm font-normal">
      <span className="text-muted-foreground">Wirklich abbrechen?</span>
      <Button variant="destructive" size="sm" disabled={cancel.isPending} onClick={() => cancel.mutate()}>
        Ja, abbrechen
      </Button>
      <Button variant="ghost" size="sm" disabled={cancel.isPending} onClick={() => setConfirming(false)}>
        Nein
      </Button>
    </span>
  );
}
